module.exports = __webpack_public_path__ + "img/application7.cbd05651.png";